import { MenuItem } from '@/core/models';
import { CartCalculationRule, CartDomainContext } from '..';
import { MenuItemValidatorUtil } from '../utils';

export class CartItemSyncRule implements CartCalculationRule {
	/**
	 * Sincroniza los menu items del carrito con los datos recibidos desde el backend.
	 */
	calculate(context: CartDomainContext): CartDomainContext {
		const syncedItems: MenuItem[] = context.menuItems.map(cartItem => {
			const cloudMenuItem = context.cloudMenuItems
				?.filter(item => this.isValid(item))
				?.find(item => item.idArticulo === cartItem.idArticulo);

			const localPriceValue = cartItem?.precio ?? 0n;
			const localChannelProducts = cartItem?.productosCanal || [];
			const [{ precios: localProductChannelPrices }] = localChannelProducts;
			const cloudChannelProducts = cloudMenuItem?.productosCanal || [];
			const [{ precios: cloudProductChannelPrices }] = cloudChannelProducts;

			let matchedPrice = localProductChannelPrices.find(p => p.precio === localPriceValue);

			if (!matchedPrice) matchedPrice = cloudProductChannelPrices.find(p => p.precio === localPriceValue);

			let updatedPriceObj = cloudProductChannelPrices.find(p => p.idPrecio === matchedPrice?.idPrecio);
			const cartItemChanged = !updatedPriceObj;

			return {
				...cartItem,
				...(!cartItemChanged ? cartItem : cloudMenuItem),
				cartItemChanged,
			};
		});

		return {
			...context,
			menuItems: syncedItems,
			cartItemChanged: syncedItems.some(({ cartItemChanged }) => !!cartItemChanged),
		};
	}

	/**
	 * Validaciones de los menu items antes de sincronizar
	 */
	private isValid(menuItem: MenuItem): boolean {
		return MenuItemValidatorUtil.isValid(menuItem);
	}
}
